<template>
    <div id="contenedor-album-frentes-main">
        <album-frentes
        :idContrato="idContrato"
        modulo="ejecucion">

        </album-frentes>
    </div>
</template>
<script>
import AlbumFrentes from '@/components/administracion/albumfrentes/Main.vue';

export default {
  name: 'MainAlbumFrentes',
  data() {
    return {
      idContrato: this.$route.params.idContrato,
    };
  },
  components: {
    AlbumFrentes,
  },
};
</script>
